import List from 'src/storage/list';
import moment from 'moment';
import { isAdminPage } from 'src/helpers';

class LastSalesModel extends List {
  id = 'lastSales';
  defaultState = () => ({
    current: 'recent',
    pageIndex: 0,
    sortBy: {
      key: 'created',
      desc: true
    },
    endDate: moment()
  });
  refreshOnInit = false;
  refreshOnSubscribe = false;
  apiConfig = {
    refresh: {
      url: 'doctorStats/last',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    list: {
      url: 'doctorStats/last',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    }
  };

  listLimit = 5;

  listParams() {
    let req = {
      skip: this.state.pageIndex * this.listLimit,
      limit: this.listLimit
      // sortBy: this.state.sortBy,
      // dateType: this.state.type || 'all',
      // period: this.state.period || 'day'
    };
    if (isAdminPage()) req.admin = true;
    return req;
  }
}

const model = new LastSalesModel();
export default model;
